var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQdrantIconStreamlineSvgLogos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    id: "Qdrant-Icon--Streamline-Svg-Logos",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Qdrant Icon Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24386c",
    d: "m71.3132 87.4033-1.8743-51.6755-3.3945-13.6238 22.6571 2.3986v62.5096L74.8612 95l-3.548-7.5967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7589be",
    d: "m88.7001 24.4989-13.8403 7.9934-28.5614-6.2652-33.4307 13.6115-5.56985-15.3397L27.6451 12.7495 47.9985 1l20.3479 11.7495 20.3537 11.7494Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2bfe8",
    d: "m7.29883 24.4992 13.84027 7.9933 8.023 23.8604 27.0891 21.6745-8.2511 16.9686-20.3534-11.7501L7.29883 71.4964V24.4985"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#24386c",
    d: "M57.1757 65.4897 48 79.0167v15.9806l13.02-7.5123 6.7086-10.0176"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7589be",
    d: "M48.0055 63.0408 34.98 40.4887l2.8056-7.4747 10.6658-5.1712L61.0199 40.489 48.0055 63.0408Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2bfe8",
    d: "m34.9797 40.4873 13.02 7.5123v15.0368l-12.0418.5181-7.2841-9.3009 6.3059-13.7663"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#24386c",
    d: "m48 47.998 13.02-7.5117 8.8611 14.7544-10.7231 8.8599L48 63.0353V47.998Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc244c",
    d: "m61.0195 87.4835 13.8403 7.5129V32.4929l-13.4332-7.7528-13.4271-7.7528-13.4333 7.7528-13.427 7.7528v31.0167l13.427 7.7528 13.4333 7.7535 13.02-7.5191v15.9867Zm0-31.9672-13.02 7.5184-13.02-7.5184V40.4856l13.02-7.5184 13.02 7.5184v15.0307Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M48.0054 79.0217V63.0388l-12.9522-7.4543v15.9564l12.9522 7.4808Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1091.46,
    x2: -199.196,
    y1: 1106.56,
    y2: 1106.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c91540",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQdrantIconStreamlineSvgLogos);
export default __webpack_public_path__ + "static/media/Qdrant-Icon--Streamline-Svg-Logos.4812158dfd2ff959b875367d473b0287.svg";
export { ForwardRef as ReactComponent };